module.exports = __webpack_public_path__ + "img/kt_logo.6c7e85eb.png";